/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { toast } from "react-toastify";
import { getMasterConfig } from '@src/store/slices/common';
import {addAgencyUsers} from '@src/store/slices/agency';
import ToggleSwitch from '@src/common/ToggleSwitch';
import InputField from "@src/common/InputField"
import { STATUS_SUCCESS } from "@src/config/constant";

function AgencyUserListPopup(props: any) {
    const dispatch: any = useDispatch();
    let { showUserPopup, userEditPopup, userDetails } = props;
    let [additional_feature_list, setAdditionalFeatureList] = useState<any>([]);
    let [formData, setFormData] = useState<any>({ ...userDetails || {} });
    let [errors, setErrors] = useState<any>({});
    // const mobile_regex = /^[0-9]{9,12}$/;
    const mobile_regex = /^[9]\d{9}$/;
    const email_regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const password_regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    
    
    const commonState = useSelector((state: any) => state.common);
    useEffect(() => {
        if (Object.keys(commonState.common).length === 0) {
            dispatch(getMasterConfig());
        }
        // eslint-disable-next-line
    }, []);

    
    const handleChange = async (key: any, event: any) => {
        let value: any = '';
        if (key === 'status') {
            value = formData.status === "1" ? "0" : "1";
        }
        else if (event instanceof Array) value = event.map((e: any) => e.value);
        else if (event && event.target) value = event.target.value;
        else if (event) value = event.value;
        if (key === 'reportee_role_id') formData.reportee_id = ''
        formData[key] = value;
        errors[key] = '';

        setErrors({ ...errors });
        setAdditionalFeatureList([...additional_feature_list]);
        setFormData({ ...formData });
       
    }

    const isFormValid = async (formData: any) => {
        let isValid = true;
        if (!formData.name || formData.name === '') {
            errors['name'] = "This Field is Required";
            isValid = false;
        } else if (formData && formData.name && (formData.name.split('').length < 3 || formData.name.split('').length > 30)) {
            errors['name'] = "User Name should be between 3 and 30";
            isValid = false;
        }
        if (formData?.mobile && !mobile_regex.test(formData.mobile)) {
            errors['mobile'] = 'Mobile number should start from 9 and should be 10 digits.';
            isValid = false;
        }
        if (!formData.email || formData.email === '') {
            errors['email'] = "Email is required";
            isValid = false;
        } else if (!email_regex.test(formData.email)) {
            errors['email'] = "Email is not valid";
            isValid = false;
        }
        if (formData.password && !password_regex.test(formData.password)) {
            errors['password'] = 'Password should be atleast 8 character with 1 special char,1 Uppercase,1 lowercase and 1 digit';
            isValid = false;
        }
        setErrors({ ...errors });
        return isValid;

    }


    const handleSubmit = async (e: any) => {
        e.preventDefault();
        let formData = await getFormData();
       
        if (await isFormValid(formData)) {
            props.setLoading(true);
            dispatch(addAgencyUsers(formData)).then((res: any) => {
                props.setLoading(false);
                if (res && res.status === STATUS_SUCCESS) {
                    toast.success(res.message);
                    props.setTriggerAgencyList(props.triggerAgencyList + 1);
                    setFormData({});
                    props.userEditPopup(false, {});
                    props.getUserManageListDetails({});
                }
            }).catch((err: Error) => {
                props.setLoading(false);
            })
        }
     props.setSearchText('');
    }

    const getFormData = async () => {
        let postData: any = {};
        if (formData && formData.id) postData['id'] = formData.id;
        if (formData && formData.name) postData['name'] = formData.name?.replace(/\s+/g,' ').trim();
        if (formData && formData.email) postData['email'] = formData.email?.replace(/\s+/g,' ').trim();
        if (formData && formData.password) postData['password'] = formData.password ;
        postData['mobile'] = (formData && formData.mobile)? formData.mobile: '';
        if (formData && formData.status) postData['status'] = formData.status;
        
        return postData;
    }

    
    return (
        <React.Fragment>
            {
              showUserPopup?
                <div className="edit-role-outer user-list-outer edit-user-popup-bx">
                    <div className="edit-role-main">
                        <h2>Edit User</h2>
                        <a className="close-icn"  onClick={() => userEditPopup(false)}><i className="ic-clearclose"></i></a>
                      
                        <div className="row">
                            <div className=" role-status-outer w-100">
                                <div className="col-md-6">
                                    <fieldset className="form-filed">
                                        <div className="material">
                                            <input id="" type="text" placeholder=" " name="UserName" className="form-input" onChange={(e: any) => handleChange('name', e)} value={formData.name || ''} />
                                            <label data-label="User Name*" className="form-label"></label>
                                            <span className="error-txt">
                                                {errors.name || ""}
                                            </span>
                                        </div>
                                    </fieldset>
                                </div>

                            <div className="col-md-6">
                                <fieldset className="form-filed">
                                    <div className="material status-btn">
                                        <ToggleSwitch 
                                        checked={String(formData.status) === "1" ? true : false} 
                                        onChange={(e: any) => handleChange('status', e)}
                                        />
                                        <div className="status-txt">{String(formData.status) === "1" ? "Active" : "Inactive"}</div>
                                    </div>
                                </fieldset>
                            </div>
                            </div>
                                <div className="col-md-6">
                                            <fieldset className="form-filed">
                                                <div className="material">
                                                    <InputField
                                                    inputProps={{
                                                        id: "mobile",
                                                        name: "mobile",
                                                        className: "form-input",
                                                        type: "text",
                                                        value: formData.mobile ? formData.mobile : '',
                                                        maxLength: "10",
                                                        disabled: false,
                                                        placeholder: " "

                                                    }}
                                                    onChange={(e: any) => handleChange('mobile', e)}
                                                />
                                                    <label data-label="Mobile No" className="form-label"></label>
                                                    <span className="error-txt">
                                                        {errors.mobile || ""}
                                                    </span>                                
                                                </div>
                                            </fieldset>

                                    <fieldset className="form-filed password-txt-msg">
                                        <div className="material">
                                            <input id="password" type="text" placeholder=" " name="password" className="form-input" onChange={(e: any) => handleChange('password', e)}  />
                                            <label data-label={"Password"} className="form-label"></label>
                                            <span className="error-txt">
                                                {errors.password || ""}
                                            </span>
                                        </div>
                                    </fieldset>
                                    
                                </div>
                                <div className="col-md-6">
                                    <fieldset className="form-filed">
                                        <div className="material">
                                            <input id="email" type="text" placeholder=" " name="email" className="form-input" onChange={(e: any) => handleChange('email', e)} value={formData.email || ''} />
                                            <label data-label="Email*" className="form-label"></label>
                                            <span className="error-txt">
                                                {errors.email || ""}
                                            </span>
                                        </div>
                                    </fieldset>
                                    
                                </div>
                                
                            {
                                <div className="col-md-12">
                                    <button className="btn-primary m-md-t" onClick={(e: any) => handleSubmit(e)}>Save Changes</button>
                                </div>
                            }
                        </div>
                        
                    </div>
                </div>
                :null
            }
        </React.Fragment>
    )
}
export default AgencyUserListPopup;